
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"200","height":"200","viewBox":"0 0 52.917 52.917","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.793 3.598a23.812 23.812 0 00-17.147 22.86A23.812 23.812 0 0026.458 50.27 23.812 23.812 0 0050.27 26.458a23.812 23.812 0 00-17.147-22.86l-2.14 7.644a15.875 15.875 0 0111.35 15.216 15.875 15.875 0 01-15.875 15.875 15.875 15.875 0 01-15.875-15.875 15.875 15.875 0 0111.35-15.216l-2.14-7.644z"}})])
          )
        }
      }
    